"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class AvatarDoesNotExistError extends client_library_1.ExtendableError {
    constructor(avatarId) {
        super(`Avatar ${avatarId} does not exist`);
    }
}
exports.default = AvatarDoesNotExistError;
//# sourceMappingURL=AvatarDoesNotExistError.js.map